import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import SVGWrapper from '../../SVGWrapper/index.js';

var degree = {
    up: '180deg',
    down: '0',
    left: '90deg',
    right: '-90deg',
};
var path = {
    chevron: 'M12 16L6 10L7.41 8.59L12 13.17L16.59 8.59L18 10L12 16Z',
    'direction-sign': 'M11 4L11 16.17L5.41 10.58L4 12L12 20L20 12L18.59 10.59L13 16.17L13 4L11 4Z',
    triangle: 'M7 9.66667C7 9.84722 7.06185 10.0035 7.18555 10.1354L11.5605 14.8021C11.6842 14.934 11.8307 15 12 15C12.1693 15 12.3158 14.934 12.4395 14.8021L16.8145 10.1354C16.9382 10.0035 17 9.84722 17 9.66667C17 9.48611 16.9382 9.32986 16.8145 9.19792C16.6908 9.06597 16.5443 9 16.375 9L7.625 9C7.45573 9 7.30925 9.06597 7.18555 9.19792C7.06185 9.32986 7 9.48611 7 9.66667Z',
};
function Arrow(_a) {
    var styleType = _a.styleType, direction = _a.direction, _b = _a.color, color = _b === void 0 ? '#212529' : _b, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["styleType", "direction", "color", "onClick", "style"]);
    return (React.createElement(SVGWrapper, __assign({ width: 24, height: 24, onClick: onClick, style: style }, props),
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", d: path[styleType], fill: color, style: {
                transform: "rotate(" + degree[direction] + ")",
                transformOrigin: 'center',
            } })));
}

export { Arrow as default };
